import { connect } from 'react-redux';
import  MarketoView from './MarketoView.jsx';
import { fetchIntegrations } from "src/legacy/redux/actions/integrations.jsx";
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';
import { getIntegrationForType } from 'src/legacy/redux/actions/integrations.jsx';

const mapStateToProps = (state, ownProps) => {
  let integration = getIntegrationForType(state, 'marketo');
  return {
    'integration': integration,
    integrations: state.legacyRootReducer.settings.integrations,
    deactivating: state.legacyRootReducer.settings.integrations.marketo.deactivation.deactivating
  }
}

const mapDispatchToProps = (dispatch) => {
  return {

    fetchIntegrations: () => {
      return dispatch(fetchIntegrations());
    }
    
  }
}

const MarketoPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(MarketoView);

export default withUseHooks(MarketoPage);